<template>
  <div class="drivers-responses-wrap box-container">
    <v-row no-gutters>
      <v-col cols="5" style="border-right: 1px solid rgba(0,0,0,0.1);">
        <div class="overtime-title">
          Total responses
          <!-- <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                las la-external-link-alt
              </v-icon>
            </template>
            <span>View responses</span>
          </v-tooltip> -->
        </div>
        <div class="overtime-score pb-3">
          <span v-if="driverData.response_stats && driverData.response_stats.total_responses">
            {{driverData.response_stats.total_responses}}
          </span>
          <span v-else>0</span>
        </div>
        <v-row class="stats-wrap" dense>
          <v-col class="text-center">
            <div class="p-stats">
              <div>
                <span v-if="driverData.response_stats
                  && driverData.response_stats.nps_breakdown
                  && driverData.response_stats.nps_breakdown.negative"
                  class="p-score negative"
                >
                  {{driverData.response_stats.nps_breakdown.negative}}
                </span>
                <span v-else class="p-score negative">0</span>
              </div>
            </div>
            <div class="p-title">Negative</div>
          </v-col>
          <v-col class="text-center">
            <div class="p-stats">
              <div>
                <span v-if="driverData.response_stats
                  && driverData.response_stats.nps_breakdown
                  && driverData.response_stats.nps_breakdown.neutral"
                  class="p-score neutral"
                >
                  {{driverData.response_stats.nps_breakdown.neutral}}
                </span>
                <span v-else class="p-score neutral">0</span>
              </div>
            </div>
            <div class="p-title">Neutral</div>
          </v-col>
          <v-col class="text-center">
            <div class="p-stats">
              <div>
                <span v-if="driverData.response_stats
                  && driverData.response_stats.nps_breakdown
                  && driverData.response_stats.nps_breakdown.positive"
                  class="p-score positive"
                >
                  {{driverData.response_stats.nps_breakdown.positive}}
                </span>
                <span v-else class="p-score positive">0</span>
              </div>
            </div>
            <div class="p-title">Positive</div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="7">
        <div class="overtime-title">Responses over time</div>
        <div>
          <div id="chartdiv"></div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs-ext/plugin/customParseFormat';

import DriversMixin from '../drivers-mixins';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
am4core.useTheme(am4themes_animated);

export default {
  name: 'DriversResponses',

  mixins: [DriversMixin],

  watch: {
    driverData: {
      deep: true,
      // immediate: true,
      handler () {
        if (this.driverData && this.driverData.response_stats && this.driverData.response_stats.monthwise_response_stats) {
          this.overtimeResponses(this.driverData.response_stats.monthwise_response_stats);
        }
      }
    }
  },

  mounted () {
    if (this.driverData && this.driverData.response_stats && this.driverData.response_stats.monthwise_response_stats) {
      this.overtimeResponses(this.driverData.response_stats.monthwise_response_stats);
    }
  },

  methods: {
    overtimeResponses (val) {
      const formattedData = [];
      this.$lodash.each(val, (v) => {
        formattedData.push({
          month: dayjs(v.month).format('MMM \'YY'),
          ...v.response_stats.nps_breakdown
        });
      });
      /* Create chart instance */
      var testChart = am4core.create('chartdiv', am4charts.XYChart);

      /* Add data */
      testChart.data = formattedData;
      /* Create axes */
      var categoryAxis = testChart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = 'month';
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.grid.template.disabled = true;
      categoryAxis.renderer.line.strokeOpacity = 1;
      categoryAxis.renderer.line.strokeWidth = 1.5;
      categoryAxis.renderer.line.stroke = am4core.color('#050550');
      categoryAxis.renderer.minGridDistance = 10;
      const label = categoryAxis.renderer.labels.template;
      label.fontSize = 12;

      /* Create value axis */
      // eslint-disable-next-line no-unused-vars
      var valueAxis = testChart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.line.strokeOpacity = 1;
      valueAxis.renderer.line.strokeWidth = 1.5;
      valueAxis.renderer.line.stroke = am4core.color('#050550');
      // valueAxis.renderer.labels.template.disabled = true;

      /* Create series */
      var series1 = testChart.series.push(new am4charts.LineSeries());
      series1.dataFields.valueY = 'negative';
      series1.dataFields.categoryX = 'month';
      series1.name = 'negative';
      series1.tooltipText = 'Negative: [bold]{valueY}[/]';
      series1.strokeWidth = 3;
      series1.fill = 'rgba(52, 43, 126, 0.4)';
      series1.stroke = am4core.color('rgba(52, 43, 126, 0.4)');
      series1.tensionX = 1;
      series1.fillOpacity = 0.25;
      // eslint-disable-next-line no-unused-vars
      var bullet1 = series1.bullets.push(new am4charts.CircleBullet());
      // bullet1.tooltipText = 'Negative: [bold]{value}[/]';

      var series2 = testChart.series.push(new am4charts.LineSeries());
      series2.dataFields.valueY = 'neutral';
      series2.dataFields.categoryX = 'month';
      series2.name = 'neutral';
      series2.tooltipText = 'Neutral: [bold]{valueY}[/]';
      series2.strokeWidth = 3;
      series2.fill = 'rgba(52, 43, 126, 0.7)';
      series2.stroke = am4core.color('rgba(52, 43, 126, 0.7)');
      series2.tensionX = 1;
      series2.fillOpacity = 0.25;
      // eslint-disable-next-line no-unused-vars
      var bullet2 = series2.bullets.push(new am4charts.CircleBullet());
      // bullet2.tooltipText = 'Neutral x {valueY}: [bold]{value}[/]';

      var series3 = testChart.series.push(new am4charts.LineSeries());
      series3.dataFields.valueY = 'positive';
      series3.dataFields.categoryX = 'month';
      series3.name = 'positive';
      series3.tooltipText = 'Positive: [bold]{valueY}[/]';
      series3.strokeWidth = 3;
      series3.fill = 'rgba(52, 43, 126, 1)';
      series3.fillOpacity = 0.25;
      series3.stroke = am4core.color('rgba(52, 43, 126, 1)');
      series3.tensionX = 1;
      // eslint-disable-next-line no-unused-vars
      var bullet3 = series3.bullets.push(new am4charts.CircleBullet());
      // bullet3.tooltipText = 'Positive x {valueY}: [bold]{value}[/]';

      /* Add legend */
      // testChart.legend = new am4charts.Legend();

      /* Create a cursor */
      testChart.cursor = new am4charts.XYCursor();
    }
  }
};
</script>

<style lang="scss" scoped>
.drivers-responses-wrap {
  height: 15rem;
  padding: 16px;
  .overtime-title {
    font-size: var(--content-size);
    color: var(--color-content);
    text-align: center;
  }
  .overtime-score {
    font-size: 4rem;
    text-align: center;
  }
  .stats-wrap {
    // position: absolute;
    // bottom: 0;
    display: flex;
    justify-content: space-evenly;
  }
  .p-stats {
    .p-score {
      font-size: var(--heading-size);
      font-weight: var(--heading-weight);
      color: var(--color-content);
      padding: 5px 8px;
      border-radius: 0.25rem;
      box-shadow:
        // 2px 2px 6px 0 rgba(0, 0, 0, 0.06),
        // -2px -2px 6px 0 rgba(0, 0, 0, 0.06);
        2px 2px 6px 0 #ebe9ff,
        -2px -2px 6px 0 #ebe9ff;
      &.negative {
        background-color: rgba(244, 67, 54, 0.2);
      }
      &.neutral {
        background-color: rgba(246, 251, 252, 0.2);
      }
      &.positive {
        background-color: rgba(100, 231, 100, 0.2);
      }
    }
    .p-title {
      font-size: var(--content-sub-size);
    }
  }
  #chartdiv {
    margin-top: 20px;
    margin-left: -15px;
    margin-right: -30px;
    height: 175px;
  }
}
</style>
